import { format, parseISO } from 'date-fns';
import { Link } from 'react-router-dom';

import { Icon, IconButton, Typography } from '@/ui';

import { LoadError, PageLoading } from '../PageState';
import { reflectionPath } from '../format';

import { useBackNavigation } from '@/hooks/useBackNavigation';
import { useGetCoachingNotesHomeQuery } from '@/store/api/mcpMemberApi';

const TopicsPage = () => {
  const home = useGetCoachingNotesHomeQuery();
  const back = useBackNavigation('/m');
  if (home.isLoading) return <PageLoading />;
  if (home.isError || !home.data) {
    return (
      <LoadError
        onRetry={() => {
          home.refetch().catch(() => undefined);
        }}
      />
    );
  }
  const { next_session: next, topic_ideas: topics } = home.data;

  return (
    <div>
      <header className="px-4 py-3">
        <IconButton aria-label="Back" onClick={back}>
          <Icon>arrow_back</Icon>
        </IconButton>
      </header>
      <main className="mx-auto max-w-[600px] px-6 pb-36 pt-6">
        {next && (
          <p className="m-0 text-cement-400">
            For your {format(parseISO(next.starts_at), 'MMMM d')} session with{' '}
            {next.coach_first_name}
          </p>
        )}
        <Typography className="mt-2" component="h1" variant="h4">
          Topic Ideas
        </Typography>
        <Typography className="mb-6 mt-2 text-cement-400" variant="body1">
          A few things you might bring. Pick one, or none.
        </Typography>
        {topics.length === 0 && (
          <p className="text-cement-400">Nothing here right now.</p>
        )}
        {topics.map((topic) => (
          <section
            key={`${topic.source.session_id}:${topic.headline}`}
            className="mb-7"
          >
            <Typography component="h2" variant="h6">
              {topic.headline}
            </Typography>
            <Typography className="my-1" variant="body1">
              {topic.text}
            </Typography>
            <Link className="text-sage-500" to={reflectionPath(topic.source)}>
              From your {topic.source.label} session
            </Link>
          </section>
        ))}
      </main>
    </div>
  );
};

export default TopicsPage;
